import { useContext } from "react";
import { AuthContext } from "../../auth-context";
import IOBoolean from "../../widget/io-boolean";
import IOList from "../../widget/io-list";
import IOText from "../../widget/io-text";
import Panel from "../../widget/panel";
import TwoColumns from "../../widget/two-columns";
import type { Consult } from "../_objects-patient";

export default function ConsultAbstractConclusion(props: {
  file: Consult;
}): React.ReactNode {
  const authenticationContext = useContext(AuthContext)!;

  return (
    <TwoColumns>
      <Panel fixed label="Conclusions">
        <IOText
          name="comments"
          label="Others Comments and Treatments"
          value={props.file.comments}
        />
        <IOBoolean
          name="suggested_for_surgery"
          label="Suggested for Surgery"
          value={props.file.suggested_for_surgery}
        />
        <IOList
          name="treatment_evaluation"
          value={props.file.treatment_evaluation}
          list={authenticationContext.getList("TreatmentEvaluation")}
        />
        <IOBoolean
          name="treatment_finished"
          value={props.file.treatment_finished}
        />
      </Panel>
    </TwoColumns>
  );
}
